// extracted by mini-css-extract-plugin
export default {"col1":"styles_col1__At++7","col2":"styles_col2__-0CTa"};